export default __webpack_public_path__ + "static/media/AZSortIcon.78726da2.svg";